"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityListLayout = exports.EntityListLayoutComponent = exports.EntityListLayoutDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var fetch_more_params_1 = require("../../utils/fetch-more-params");
var use_entities_1 = require("../../hooks/use-entities");
var to_array_1 = require("../../utils/to-array");
var use_app_screen_1 = require("../../hooks/use-app-screen");
var entity_list_query_1 = require("../../utils/entity-list-query");
var lodash_1 = require("lodash");
var client_1 = require("@apollo/client");
var react_infinite_scroll_hook_1 = __importDefault(require("react-infinite-scroll-hook"));
var use_lang_1 = require("../../hooks/use-lang");
var use_icons_1 = require("../../hooks/use-icons");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var error_message_1 = require("../elements/error-message");
var entity_grid_1 = require("./entity-grid");
var entity_table_1 = require("./entity-table");
var info_message_1 = require("../elements/info-message");
var layout_1 = require("../elements/layout");
var wait_message_1 = require("../elements/wait-message");
var search_input_1 = require("../elements/search-input");
var list_controls_layout_1 = require("../elements/list-controls-layout");
var sprintf_js_1 = require("sprintf-js");
var entity_filters_1 = require("./entity-filters");
var loading_layout_1 = require("../elements/loading-layout");
var entity_search_toggles_1 = require("./entity-search-toggles");
var router_1 = require("@reach/router");
var entity_list_banner_1 = require("./entity-list-banner");
var entity_list_1 = require("./entity-list");
var entity_row_1 = require("./entity-row");
var menu_context_1 = require("../context/menu-context");
var current_user_can_1 = require("../../utils/current-user-can");
var utils_1 = require("@shapeable/utils");
exports.EntityListLayoutDefaultProps = {
  loadingMessage: 'Loading. Please wait...',
  showBanner: true,
  showFilters: true,
  paramState: '',
  showToggles: true,
  filterFieldNames: [],
  autoFocus: true,
  toggleFieldNames: ['isPublished', 'isDuplicate', 'isDraft', 'isMember', 'isActive', 'isAll', 'hasComments']
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 100%;\n    box-sizing: border-box;\n    overflow-y: auto;\n  "], ["\n    height: 100%;\n    box-sizing: border-box;\n    overflow-y: auto;\n  "])))
});
var ResultsLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    padding-bottom: ", ";\n    padding: 0;\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    padding-bottom: ", ";\n    padding: 0;\n    ", "\n  "])), theme_1.theme.UNIT(12), function (_a) {
    var hasSpace = _a.hasSpace;
    return hasSpace && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme_1.theme.UNIT(3));
  }),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TableStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ErrorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var FiltersLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    overflow: visible;\n    z-index: 70;\n    padding: 0;\n    margin-left: -", ";\n    margin-right: -", ";\n    border-bottom: 1px solid ", ";\n    margin-bottom: ", ";\n  "], ["\n    overflow: visible;\n    z-index: 70;\n    padding: 0;\n    margin-left: -", ";\n    margin-right: -", ";\n    border-bottom: 1px solid ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(3)),
  tablet: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    border-bottom: none;\n    margin-bottom: 0;\n\n  "], ["\n    border-bottom: none;\n    margin-bottom: 0;\n\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-left: 0;\n    margin-right: 0;\n    \n  "], ["\n    margin-left: 0;\n    margin-right: 0;\n    \n  "])))
});
var FiltersStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    color: ", ";\n    font-family: ", ";\n    font-weight: 300;\n  "], ["\n    color: ", ";\n    font-family: ", ";\n    font-weight: 300;\n  "])), theme_1.theme.COLOR('light'), theme_1.theme.FONT('sans'))
});
var SearchInputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: none;\n    flex-grow: 1;\n  "], ["\n    box-sizing: border-box;\n    display: none;\n    flex-grow: 1;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var SearchInputShortStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n  "], ["\n    display: flex;\n    flex-grow: 1;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var ListControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "]))),
  maxContent: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListControlsBodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  "])))
});
var LayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ListControlsLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    z-index: 50;\n    padding-bottom: 0;\n    padding-top: 0;\n    margin-bottom: ", ";\n    margin-top: ", ";\n    margin-left: -", ";\n    margin-right: -", ";\n  "], ["\n    z-index: 50;\n    padding-bottom: 0;\n    padding-top: 0;\n    margin-bottom: ", ";\n    margin-top: ", ";\n    margin-left: -", ";\n    margin-right: -", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(1), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3)),
  tablet: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    margin-left: 0;\n    margin-right: 0;\n  "], ["\n    margin-left: 0;\n    margin-right: 0;\n  "])))
});
var InfiniteContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var WaitMessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(6), theme_1.theme.UNIT(25)),
  tablet: (0, styled_components_1.css)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var EmptyMessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    margin: ", " auto;\n  "], ["\n    margin: ", " auto;\n  "])), theme_1.theme.UNIT(12))
});
var LoadingLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EntitySearchTogglesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListControlsContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return !props.hasImage && (0, styled_components_1.css)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n      padding: 0;\n    "], ["\n      padding: 0;\n    "])));
  })
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    padding: ", ";\n\n  "], ["\n    padding: ", ";\n\n  "])), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ResultsLayout: styled_components_1.default.div(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), ResultsLayoutStyles),
  Grid: (0, styled_components_1.default)(entity_grid_1.EntityGrid)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Table: (0, styled_components_1.default)(entity_table_1.EntityTable)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), TableStyles),
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  ErrorMessage: (0, styled_components_1.default)(error_message_1.ErrorMessage)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), ErrorStyles),
  EmptyMessage: (0, styled_components_1.default)(info_message_1.InfoMessage)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), EmptyMessageStyles),
  LoadingLayout: (0, styled_components_1.default)(loading_layout_1.LoadingLayout)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), LoadingLayoutStyles),
  Layout: (0, styled_components_1.default)(layout_1.Layout)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Banner: (0, styled_components_1.default)(entity_list_banner_1.EntityListBanner)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  FiltersLayout: (0, styled_components_1.default)(layout_1.Layout)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), FiltersLayoutStyles),
  FiltersContainer: styled_components_1.default.div(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), FiltersStyles),
  WaitMessage: (0, styled_components_1.default)(wait_message_1.WaitMessage)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageStyles),
  SearchInput: (0, styled_components_1.default)(search_input_1.SearchInput)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), SearchInputStyles),
  SearchInputShort: (0, styled_components_1.default)(search_input_1.SearchInput)(templateObject_46 || (templateObject_46 = __makeTemplateObject(["", ""], ["", ""])), SearchInputShortStyles),
  ListControlsLayout: (0, styled_components_1.default)(layout_1.Layout)(templateObject_47 || (templateObject_47 = __makeTemplateObject(["", ""], ["", ""])), ListControlsLayoutStyles),
  ListControlsContainer: (0, styled_components_1.default)(layout_1.Layout)(templateObject_48 || (templateObject_48 = __makeTemplateObject(["", ""], ["", ""])), ListControlsContainerStyles),
  ListControls: (0, styled_components_1.default)(list_controls_layout_1.ListControlsLayout)(templateObject_49 || (templateObject_49 = __makeTemplateObject(["", ""], ["", ""])), ListControlsStyles),
  ListControlsBody: styled_components_1.default.div(templateObject_50 || (templateObject_50 = __makeTemplateObject(["", ""], ["", ""])), ListControlsBodyStyles),
  InfiniteContainer: styled_components_1.default.div(templateObject_51 || (templateObject_51 = __makeTemplateObject(["", ""], ["", ""])), InfiniteContainerStyles),
  EntitySearchToggles: (0, styled_components_1.default)(entity_search_toggles_1.EntitySearchToggles)(templateObject_52 || (templateObject_52 = __makeTemplateObject(["", ""], ["", ""])), EntitySearchTogglesStyles)
};
var EntityListLayoutComponent = function (props) {
  var _a, _b;
  var className = props.className,
    entityTypeName = props.entityTypeName,
    applyFilterState = props.applyFilterState,
    autoFocus = props.autoFocus,
    showBanner = props.showBanner,
    queryVariant = props.queryVariant,
    filterFieldNames = props.filterFieldNames,
    paramState = props.paramState,
    baseRoute = props.baseRoute,
    toggleFieldNames = props.toggleFieldNames,
    junctionEntityTypeName = props.junctionEntityTypeName;
  if (!entityTypeName) {
    throw new Error("Entity List cannot be created. Missing entity configuration.");
  }
  utils_1.ginni.group("EntityListLayout: ".concat(entityTypeName));
  var entities = (0, use_entities_1.useEntities)();
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var baseState = definition.list.baseState;
  var baseFilter = baseState && baseState.filter || {
    isPublished: {
      is: true
    }
  };
  var _c = __read(React.useState(''), 2),
    nameState = _c[0],
    setNameState = _c[1];
  var screen = (0, use_app_screen_1.useAppScreen)();
  // gather field info, based on available filters (perhaps we could move this into entity definitions??)
  var SLUG_MAP = {
    hasComments: 'conversations'
  };
  var fieldInfo = React.useMemo(function () {
    // @ts-ignore
    return (0, lodash_1.pickBy)(__assign(__assign({}, (0, lodash_1.mapValues)(definition.filters.fields, function (field, fieldName) {
      var defn = field.entityTypeName && entities[field.entityTypeName];
      if (defn) {
        return {
          slug: defn.pluralSlug,
          name: fieldName,
          method: 'in'
        };
      } else {
        // assume this is just a select
        return {
          slug: (0, lodash_1.kebabCase)(fieldName),
          name: fieldName,
          method: 'in'
        };
      }
    })), (0, lodash_1.keyBy)(toggleFieldNames.map(function (name) {
      return {
        slug: SLUG_MAP[name] || (0, lodash_1.kebabCase)(name).replace(/(is|has)-/, ''),
        name: name,
        method: "is"
      };
    }), 'name')));
  }, [entityTypeName]);
  var fieldInfoBySlug = React.useMemo(function () {
    return (0, lodash_1.keyBy)(fieldInfo, 'slug');
  }, [fieldInfo]);
  var showDuplicatesToggle = (0, current_user_can_1.currentUserCan)(['write:any', 'admin:any']);
  var parseParamState = function () {
    var parts = paramState ? paramState.split('/') : [];
    // console.log("PARTS", parts);
    var parsedState = parts.reduce(function (acc, part) {
      var nameValue = part.split(':');
      // console.log("NAME VALUE", nameValue);
      if (nameValue.length) {
        var _a = __read(nameValue, 2),
          name_1 = _a[0],
          value = _a[1];
        var info = fieldInfoBySlug[name_1];
        if (info) {
          // here, we need to establish if this value is a boolean
          if (info.method === 'is') {
            acc.filter[info.name] = {
              is: true
            };
          } else if (info.method === 'in') {
            if (value) {
              acc.filter[info.name] = {
                in: value.split(',')
              };
            }
          } else if (info.method === 'contains') {
            if (value) {
              acc.filter[info.name] = {
                contains: value
              };
            }
          }
        } else {
          // check if this is an orderBy
          if (name_1 === 'order-by') {
            acc.orderBy = {
              fieldName: value,
              desc: (nameValue === null || nameValue === void 0 ? void 0 : nameValue[2]) === 'desc'
            };
          }
          if (name_1 === 'duplicates') {
            acc.duplicatesOnly = true;
          }
        }
      }
      return acc;
    }, {
      filter: {}
    });
    // splice in the name from search
    parsedState.filter.name = {
      contains: nameState
    };
    return parsedState;
  };
  /*
    This allows external consumers to
    apply a contextual filter on top of the filtering performed by user interactions
  */
  var appliedListState = function (filterState) {
    var newState = applyFilterState ? applyFilterState(filterState) : filterState || {};
    // Remove any null filters, which allows `applyFilterState` to remove filters which would normally be set
    var filteredState = __assign(__assign(__assign({}, baseState), newState), {
      filter: (0, lodash_1.pickBy)(__assign(__assign({}, baseFilter), (0, lodash_1.pickBy)(newState.filter)), function (item) {
        // ensure that empty contains values are not sent through
        if (item.contains !== undefined && !item.contains) {
          return false;
        }
        return item;
      })
    });
    // need to remove any "anti-state" here. E.g., if isDraft is true, then isPublished must be removed from filters
    if ((0, lodash_1.get)(filteredState, 'filter.isDraft.is') === true) {
      delete filteredState.filter.isPublished;
    }
    if ((0, lodash_1.get)(filteredState, 'filter.isAll.is') === true) {
      delete filteredState.filter.isActive;
    }
    if ((0, lodash_1.get)(filteredState, 'filter.isAll.is') === true) {
      delete filteredState.filter.isMember;
    }
    return filteredState;
  };
  // the "controlled" state is the part of the state which is defined by ui controls, which aligns with React nomenclature
  var controlledState = parseParamState();
  var state = appliedListState(controlledState);
  // pick filter parts which are relevant to toggle state
  var togglesState = (0, lodash_1.pickBy)(__assign(__assign({}, (0, lodash_1.pick)(state.filter || {}, toggleFieldNames)), {
    duplicatesOnly: state.duplicatesOnly
  }));
  // const nameValue = get(state, 'filter.name.contains', '');
  var icons = (0, use_icons_1.useIcons)();
  // transforms filters from core scalar values to the correct syntax for queries 
  var filterValue = function (value, info) {
    if (info) {
      if (info.method === 'in') {
        return {
          in: value
        };
      }
      if (info.method === 'is') {
        return {
          is: value
        };
      }
      if (info.method === 'contains') {
        return value ? {
          contains: value
        } : '';
      }
    }
    return '';
  };
  var serializedValue = function (value, info) {
    if (info) {
      if (info.method === 'in' && value.in) {
        return (0, to_array_1.toArray)(value.in).join(',');
      }
      if (info.method === 'is' && value.is) {
        return 'TRUE';
      }
      if (info.method === 'contains' && value.contains) {
        return value.contains;
      }
    }
    return '';
  };
  var serializeState = function (state) {
    var parts = (0, lodash_1.filter)((0, lodash_1.map)(state.filter || {}, function (value, fieldName) {
      var info = fieldInfo[fieldName];
      var sv = serializedValue(value, info);
      if (sv === 'TRUE') {
        return info.slug; // true values are simply regarded as true if they're present
      }
      return sv && "".concat(info.slug, ":").concat(encodeURI(sv));
    }));
    if (state.orderBy && state.orderBy.fieldName) {
      parts.push("order-by:".concat(state.orderBy.fieldName).concat(state.orderBy.desc ? ':desc' : ''));
    }
    if (state.duplicatesOnly) {
      parts.push('duplicates');
    }
    return parts.join('/');
  };
  var navigateToState = function (state) {
    var serialized = serializeState(state);
    // console.log("CURRENT SERIALIZED", serialized);
    (0, router_1.navigate)("".concat(baseRoute || definition.toList(), "/").concat(serialized));
  };
  var t = (0, use_lang_1.useLang)();
  var filters = definition.filters,
    useActive = definition.useActive,
    useMembership = definition.useMembership,
    usePublishStatus = definition.usePublishStatus;
  var listConfig = definition.list;
  var emptyMessage = props.emptyMessage || listConfig.emptyMessage;
  var pad = props.pad === undefined ? listConfig.pad : props.pad;
  var queryFieldName = listConfig.queryFieldName,
    resultsVariant = listConfig.resultsVariant,
    fieldName = listConfig.fieldName,
    scrollCheckInterval = listConfig.scrollCheckInterval,
    scrollThreshold = listConfig.scrollThreshold,
    searchPlaceholder = listConfig.searchPlaceholder,
    searchPlaceholderShort = listConfig.searchPlaceholderShort,
    loadingMessage = listConfig.loadingMessage,
    bannerConfig = listConfig.banner,
    hasFilters = listConfig.hasFilters,
    hasSearch = listConfig.hasSearch,
    postBanner = listConfig.postBanner,
    preBanner = listConfig.preBanner;
  var junctionDefinition = junctionEntityTypeName && entities[junctionEntityTypeName];
  // if there is a junctionEntityTypeName. we should build a query dynamically which grabs the dependent entities fields
  var query = junctionDefinition && fieldName ? (0, entity_list_query_1.entityListQuery)(definition, {
    queryFields: "".concat(definition.list.queryFields, " ").concat(fieldName, " { id name slug isDraft isPublished ").concat(junctionDefinition.list.queryFields, " }"),
    entities: entities
  }) : listConfig.query;
  var onSearchChange = function (value) {
    setNameState(value);
  };
  var onSearchTogglesChange = function (value) {
    // patch controlled state and navigate to the new state
    // here we remove all known-toggle states from filters first, essentially resetting them
    // console.log("SEARCH TOGGLES VALUE", value);
    var valueWithDefaults = (0, lodash_1.omitBy)(value, function (fieldValue, fieldName) {
      return (0, lodash_1.isEqual)(baseFilter[fieldName], fieldValue);
    });
    var newState = __assign(__assign({}, controlledState), {
      duplicatesOnly: value.duplicatesOnly,
      filter: (0, lodash_1.omit)(__assign(__assign({}, (0, lodash_1.omit)(controlledState.filter, toggleFieldNames)), valueWithDefaults), 'duplicatesOnly')
    });
    navigateToState(newState);
  };
  var onFiltersChange = function (values) {
    // console.log("FILTERS CHANGE VALUES", values);
    // infer which fields are empty, which should be omitted from the controlledState
    var emptyFieldNames = (0, lodash_1.keys)((0, lodash_1.omitBy)(values));
    var filters = (0, lodash_1.reduce)((0, lodash_1.pickBy)(values), function (acc, value, fieldName) {
      var info = fieldInfo[fieldName];
      acc[fieldName] = filterValue(value, info);
      return acc;
    }, {});
    var newState = __assign(__assign({}, controlledState), {
      filter: __assign(__assign({}, (0, lodash_1.omit)(controlledState.filter, emptyFieldNames)), filters)
    });
    navigateToState(newState);
  };
  var defaultData = {};
  var _d = (0, client_1.useQuery)(query, {
      fetchPolicy: "network-only",
      returnPartialData: true,
      errorPolicy: "ignore",
      notifyOnNetworkStatusChange: true,
      variables: __assign(__assign({}, state), {
        skip: 0
      })
    }),
    _e = _d.data,
    data = _e === void 0 ? defaultData : _e,
    error = _d.error,
    loading = _d.loading,
    fetchMore = _d.fetchMore;
  utils_1.ginni.log("Data:", data);
  utils_1.ginni.log("Error:", error);
  var displayError = error && error.message.match(/Unauthorised/) && React.createElement(My.ErrorMessage, null, React.createElement("p", null, "Sorry, you are currently unauthorised to view this content. Please ", React.createElement("a", {
    href: ""
  }, "refresh the page"), " to renew your session."), React.createElement("p", null, "If you are still having trouble seeing this content, please ", React.createElement("a", {
    href: "/logout"
  }, "Logout"), " of the system, and try to visit this page again using the site navigation."));
  var filterItems = listConfig.filterItems || function (items) {
    return items;
  };
  var items = data[queryFieldName] && data[queryFieldName].results || [];
  var meta = data && data[queryFieldName] && data[queryFieldName].meta || {
    count: 0,
    total: 0
  };
  var hasNextPage = meta.total > items.length;
  var onLoadMore = function () {
    fetchMore((0, fetch_more_params_1.fetchMoreParams)(state, items, queryFieldName));
  };
  var _f = __read((0, react_infinite_scroll_hook_1.default)({
      loading: loading,
      hasNextPage: hasNextPage,
      onLoadMore: onLoadMore,
      disabled: false,
      rootMargin: '0px 0px 100px 0px'
    }), 2),
    sentryRef = _f[0],
    rootRef = _f[1].rootRef;
  var Filters = definition.components.filters || entity_filters_1.EntityFilters;
  var filtersValues = React.useMemo(function () {
    return (0, lodash_1.pickBy)(filters.values(state));
  }, [state]);
  var Icon = definition.icon({
    icons: icons
  });
  var filteredItems = filterItems(items);
  var isLoading = loading;
  var itemsToDisplay = (0, lodash_1.uniqBy)((0, lodash_1.map)(filteredItems, function (item) {
    return listConfig.fieldName ? item[listConfig.fieldName] : item;
  }), function (item) {
    return item.id;
  });
  var showDuplicateToggle = definition.useDuplicateCheck;
  var showActiveToggle = screen.type === 'details' && useActive;
  var showDraftToggle = usePublishStatus;
  var showMembershipToggle = screen.type === 'details' && useMembership;
  var hasToggles = showDuplicateToggle || showActiveToggle || showDraftToggle || showMembershipToggle;
  // console.log("CURRENT STATE", state);
  var onOrderByChange = function (orderBy) {
    // console.log("ORDER BY CHANGE", orderBy);
    var newState = __assign(__assign({}, controlledState), {
      orderBy: {
        fieldName: orderBy.fieldName,
        desc: orderBy.direction === "desc"
      }
    });
    navigateToState(newState);
  };
  utils_1.ginni.groupEnd();
  return React.createElement(My.Container, {
    ref: rootRef,
    className: className
  }, showBanner && React.createElement(My.Banner, {
    entityTypeName: entityTypeName
  }), hasSearch && React.createElement(My.ListControlsLayout, null, React.createElement(My.ListControlsContainer, null, React.createElement(My.ListControls, {
    loading: isLoading,
    aside: hasToggles && React.createElement(My.EntitySearchToggles, {
      onChange: onSearchTogglesChange,
      value: togglesState,
      showDraftToggle: showDraftToggle,
      showActiveToggle: showActiveToggle,
      showMembershipToggle: showMembershipToggle,
      showDuplicatesToggle: showDuplicatesToggle
    })
  }, React.createElement(My.ListControlsBody, null, React.createElement(My.SearchInput, {
    placeholder: (0, sprintf_js_1.sprintf)(t(searchPlaceholder), definition.pluralLabel),
    onChange: onSearchChange
  }), React.createElement(My.SearchInputShort, {
    placeholder: (0, sprintf_js_1.sprintf)(t(searchPlaceholderShort), definition.pluralLabel),
    onChange: onSearchChange
  }))))), hasFilters && props.showFilters && React.createElement(My.FiltersLayout, {
    pad: pad,
    transparent: true
  }, React.createElement(My.FiltersContainer, null, React.createElement(Filters, {
    fieldNames: filterFieldNames,
    entityTypeName: entityTypeName,
    values: filtersValues,
    onChange: onFiltersChange
  }))), React.createElement(My.InfiniteContainer, null, React.createElement(My.ResultsLayout, {
    hasSpace: !hasSearch && !hasFilters
  }, displayError, filteredItems.length === 0 && !isLoading ? React.createElement(My.EmptyMessage, null, (0, sprintf_js_1.sprintf)(t(emptyMessage), t(definition.pluralLabel))) : React.createElement(menu_context_1.MenuProvider, {
    value: {
      useEditRoute: true
    }
  }, resultsVariant === "grid" && React.createElement(My.Grid, {
    entityTypeName: entityTypeName,
    items: itemsToDisplay
  }), resultsVariant === "table" && React.createElement(My.Table, {
    hasDetails: (0, lodash_1.includes)(definition.autoRoutes, "details"),
    orderBy: {
      fieldName: (_a = state.orderBy) === null || _a === void 0 ? void 0 : _a.fieldName,
      direction: ((_b = state === null || state === void 0 ? void 0 : state.orderBy) === null || _b === void 0 ? void 0 : _b.desc) ? 'desc' : 'asc'
    },
    onOrderByChange: onOrderByChange,
    loading: loading,
    count: meta.total,
    entityTypeName: entityTypeName,
    items: itemsToDisplay
  }), resultsVariant === "list" && React.createElement(My.List, {
    useLinks: (0, lodash_1.includes)(definition.autoRoutes, "details"),
    showDividers: true,
    showCreator: true,
    showDescription: true,
    rowComponent: definition.components.row || entity_row_1.EntityRow,
    showMenu: true,
    highlight: nameState,
    items: itemsToDisplay
  }))), (loading || hasNextPage) && !(!loading && filteredItems.length === 0) && React.createElement("div", {
    ref: sentryRef
  }, React.createElement(My.WaitMessage, {
    loading: loading
  }, (0, sprintf_js_1.sprintf)(t(loadingMessage), t(definition.pluralLabel))))));
};
exports.EntityListLayoutComponent = EntityListLayoutComponent;
exports.EntityListLayoutComponent.defaultProps = exports.EntityListLayoutDefaultProps;
exports.EntityListLayout = React.memo(exports.EntityListLayoutComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52;